import React, { memo } from 'react';

import cx from 'classnames';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

import { ICON_NAME_VS_CMP, ICON_TYPES } from './constants';

import styles from './icon.module.scss';

interface IconProps {
  icon: string | React.ReactNode;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

// className, style, onClick

const Icon = (props: IconProps) => {
  const { icon, onClick, style, className, ...rest } = props;

  if (!icon) return null;

  if (typeof icon !== 'string') {
    return (
      <div onClick={onClick} className={cx(styles.icon, className)} style={style}>
        {icon}
      </div>
    );
  }

  const RenderIcon = _get(ICON_NAME_VS_CMP, icon, null);

  if (_isNil(RenderIcon)) {
    return null;
  }

  return (
    <div className={cx(styles.icon, className)} onClick={onClick} style={style}>
      <RenderIcon {...rest} />
    </div>
  );
};

export default memo(Icon);

export { ICON_TYPES };
